type EnvConfig = {
  ENV: "development" | "staging" | "production";
  IS_DEV: boolean;
  IS_STAGING: boolean;
  IS_PRODUCTION: boolean;

  SUPABASE: {
    PROJECT_ID?: string;
    URL: string;
    PUBLISHABLE_KEY: string;
  };

  POSTHOG: {
    KEY?: string;
    HOST?: string;
  };

  STRIPE: {
    PUBLIC_KEY?: string;
  };

  ANALYTICS: {
    GTM_ID?: string;
    COOKIEBOT_ID?: string;
    LINKEDIN_PARTNER_ID?: string;
    FACEBOOK_PIXEL_ID?: string;
  };
};

function requireEnvString(key: string, value: string | undefined): string {
  if (!value || value.trim().length === 0) {
    throw new Error(`Missing required environment variable: ${key}`);
  }
  return value;
}

function parseOptionalString(value: string | undefined): string | undefined {
  if (!value || value.trim().length === 0) return undefined;
  return value;
}

function loadEnvConfig(): EnvConfig {
  const viteEnv = parseOptionalString(import.meta.env.VITE_ENV) as
    | "development"
    | "staging"
    | "production"
    | undefined;
  const env = viteEnv ?? (import.meta.env.DEV ? "development" : "production");

  return {
    ENV: env,
    IS_DEV: import.meta.env.DEV,
    IS_STAGING: env === "staging",
    IS_PRODUCTION: env === "production",

    SUPABASE: {
      PROJECT_ID: parseOptionalString(import.meta.env.VITE_SUPABASE_PROJECT_ID),
      URL: requireEnvString(
        "VITE_SUPABASE_URL",
        import.meta.env.VITE_SUPABASE_URL
      ),
      PUBLISHABLE_KEY: requireEnvString(
        "VITE_SUPABASE_PUBLISHABLE_KEY",
        import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY
      ),
    },

    POSTHOG: {
      KEY: parseOptionalString(import.meta.env.VITE_PUBLIC_POSTHOG_KEY),
      HOST: parseOptionalString(import.meta.env.VITE_PUBLIC_POSTHOG_HOST),
    },

    STRIPE: {
      PUBLIC_KEY: parseOptionalString(import.meta.env.VITE_STRIPE_PUBLIC_KEY),
    },

    ANALYTICS: {
      GTM_ID: parseOptionalString(import.meta.env.VITE_GTM_ID),
      COOKIEBOT_ID: parseOptionalString(import.meta.env.VITE_COOKIEBOT_ID),
      LINKEDIN_PARTNER_ID: parseOptionalString(
        import.meta.env.VITE_LINKEDIN_PARTNER_ID
      ),
      FACEBOOK_PIXEL_ID: parseOptionalString(
        import.meta.env.VITE_FACEBOOK_PIXEL_ID
      ),
    },
  };
}

export const envConfig = loadEnvConfig();
